document.addEventListener('DOMContentLoaded', () => {
  const fadeElements = document.querySelectorAll('.scroll-fade-up');

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
        observer.unobserve(entry.target); // Remove observer after animation triggers
      }
    });
  }, {
    threshold: 0.2 // Trigger when 20% of element is visible
  });

  fadeElements.forEach(el => observer.observe(el));
});
